module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/art-map-medium-46d11d7c412fdf15c58a2d258ab52466.jpg";